(() => {
  const gallerySelector = '.js-tc-card-gallery';
  let observerScheduled = false;

  function getSwiperConstructor() {
    if (typeof window.Swiper !== 'undefined') return window.Swiper;
    if (typeof Swiper !== 'undefined') return Swiper;
    return undefined;
  }

  function initGallery(gallery) {
    if (gallery.dataset.tcGalleryInitialized === 'true') return;

    const SwiperConstructor = getSwiperConstructor();
    if (!SwiperConstructor) return;

    const slides = gallery.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    gallery.dataset.tcGalleryInitialized = 'true';

    gallery.tcSwiper = new SwiperConstructor(gallery, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      watchOverflow: true,
      pagination: {
        el: gallery.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },
    });
  }

  function initProductCardGalleries(root = document) {
    if (root.matches?.(gallerySelector)) {
      initGallery(root);
    }

    root.querySelectorAll?.(gallerySelector).forEach(initGallery);
  }

  function scheduleInit(root = document) {
    if (observerScheduled) return;
    observerScheduled = true;

    requestAnimationFrame(() => {
      observerScheduled = false;
      initProductCardGalleries(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductCardGalleries();

    const observer = new MutationObserver((mutations) => {
      const shouldInit = mutations.some((mutation) =>
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(gallerySelector) || node.querySelector?.(gallerySelector)),
        ),
      );

      if (shouldInit) scheduleInit();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initProductCardGalleries(event.target);
  });

  window.TCProductCardGallery = {
    init: initProductCardGalleries,
  };
})();
